import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import {
  Col,
  Container,
  Row,
  Card,
  Text,
  Divider,
  Title
} from '@qonsoll/react-design'
import { useHistory } from 'react-router-dom'
import { CardDropdown, SelectableCard } from 'components'
import { useSimpleFormActions } from 'hooks'
import { useParams } from 'react-router-dom'
import { updateParentHasManyRelationship } from 'hooks'

const ApplicationSimpleView = (props) => {
  const { application, onSelect, onDelete, index, isSelected, actions } = props

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const history = useHistory()
  const { handleDelete: removeDocument } = useSimpleFormActions({
    document: application,
    collectionName: 'applications'
  })
  const params = useParams()

  // [HANDLERS]
  const handleOpen = () => {
    history.push(`/applications/${application?._id}`)
  }
  const handleEdit = () => {
    history.push(`/applications/${application?._id}/edit`)
  }
  const handleDelete = (item, index) => {
    removeDocument()
    if (params.customerId)
      updateParentHasManyRelationship(
        params.customerId,
        'customers',
        'applicationIds',
        item?._id,
        true
      )
  }
  const handleSelect = (e) => {
    e.stopPropagation()
    onSelect?.(application?._id)
  }

  return (
    <CardDropdown
      onDelete={handleDelete}
      onEdit={handleEdit}
      onDoubleClick={handleOpen}
      onClick={handleSelect}
      document={application}
      index={index}
      {...actions}>
      <SelectableCard isSelected={isSelected}>
        <Row
          noGutters
          justifyContent="center"
          alignItems="center"
          py="4px"
          mb={2}>
          <Col>
            <Title
              level={4}
              overflow="hidden"
              textOverflow="ellipsis"
              maxWidth="250px"
              whiteSpace="nowrap">
              {application?.name}
            </Title>
          </Col>
        </Row>
        <Divider />
        <Row
          noGutters
          justifyContent="center"
          alignItems="center"
          py="4px"
          mb={2}>
          <Col>
            <Text>{t('Page ids')}</Text>
          </Col>
          <Col cw="auto">
            <Text
              overflow="hidden"
              textOverflow="ellipsis"
              maxWidth="250px"
              whiteSpace="nowrap">
              {application?.pageIds}
            </Text>
          </Col>
        </Row>
      </SelectableCard>
    </CardDropdown>
  )
}

ApplicationSimpleView.propTypes = {
  application: PropTypes.object,
  onSelect: PropTypes.func,
  onDelete: PropTypes.func,
  index: PropTypes.number,
  isSelected: PropTypes.bool,
  actions: PropTypes.shape({
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onClick: PropTypes.func
  })
}

export default ApplicationSimpleView
